var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:[
    'btn',
    {
      'btn--full': _vm.full,
      'btn--short': _vm.short,
      'btn--mobile': _vm.mobile,
     [`btn--${_vm.variant}`]: _vm.variant,
     [`btn--${_vm.size}`]: _vm.size,
     ['btn--negative']: _vm.negative,
     'btn--sec--negative': _vm.negative && (_vm.variant === 'secondary' || _vm.variant === 'tertiary'),
   }
  ],attrs:{"type":_vm.submit ? 'submit' : 'button',"disabled":_vm.disabled || _vm.loading || _vm.uploading},on:{"click":_vm.handleClick}},[_vm._t("default"),(_vm.loading)?_c('span',{staticClass:"btn__loader"}):_vm._e(),(_vm.uploading)?_c('span',{staticClass:"btn__uploader"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }